import { render } from "./listarXml.vue?vue&type=template&id=2dc9c1b8&scoped=true"
import script from "./listarXml.vue?vue&type=script&lang=js"
export * from "./listarXml.vue?vue&type=script&lang=js"

import "./listarXml.vue?vue&type=style&index=0&id=2dc9c1b8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc9c1b8"]])

export default __exports__